<template>
  <div class="home">
    <van-nav-bar
      class="nav"
      :title="$t('SetSeat.title')"
      left-arrow
      fixed
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
      <div slot="right">
        <van-icon
          v-if="isDelSeatShow == false"
          name="./static/img/dele_staff.png"
          slot="right"
          @click="isDelSeatShow = true"
          size="25px"
        />
        <van-icon
          v-else
          name="./static/img/ok.png"
          slot="right"
          @click="isDelSeatShow = false"
          size="25px"
        />
      </div>
    </van-nav-bar>
    <van-tabs v-if="seats.length > 0" v-model="actTab" sticky :offset-top="46">
      <van-tab v-for="(floor, index) in seats" :key="index" :title="floor.name">
        <van-grid
          class="mt10"
          :border="false"
          :gutter="10"
          :column-num="5"
          square
        >
          <van-grid-item
            v-for="(place, key) in floor.place"
            :key="key"
            class="setBg"
            @click="editPlaceShow(key)"
          >
            <div class="grid_item" slot="default">
              <div class="grid_item_text">{{ place.name }}</div>
              <div class="grid_item_text">{{ place.number }}人</div>
              <van-icon
                v-show="isDelSeatShow"
                @click.stop="delSeat(place.id)"
                class="grid_item_del_icon"
                name="./static/img/dele_Seat.png"
                size="20px"
              />
            </div>
          </van-grid-item>
        </van-grid>
      </van-tab>
    </van-tabs>
    <div class="editBar">
      <div class="editBar_item" @click="isAddFloorShow = true">
        <van-image width="40" height="40" src="./static/img/seat_add.png" />
        <div class="editBar_title">{{ $t("SetSeat.floor") }}</div>
      </div>
      <div class="editBar_item" @click="isDelFloorShow = true">
        <van-image width="40" height="40" src="./static/img/Seat_dele.png" />
        <div class="editBar_title">{{ $t("SetSeat.floor") }}</div>
      </div>
      <div class="editBar_item" @click="addSeat()">
        <van-image width="40" height="40" src="./static/img/seat_add.png" />
        <div class="editBar_title">{{ $t("SetSeat.seat") }}</div>
      </div>
      <div class="editBar_item" @click="isDelSeatShow = true">
        <van-image width="40" height="40" src="./static/img/Seat_dele.png" />
        <div class="editBar_title">{{ $t("SetSeat.seat") }}</div>
      </div>
      <div class="editBar_item" @click="downloadZip()">
        <van-image width="40" height="40" src="./static/img/xiazai_img.png" />
        <div class="editBar_title">{{ $t("SetSeat.downLoadQRcode") }}</div>
      </div>
    </div>
    <van-popup
      v-model="isAddFloorShow"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div>
        <van-cell-group>
          <van-cell title="">
            <van-icon
              slot="right-icon"
              name="./static/img/dele_Seat.png"
              size="25px"
              @click="isAddFloorShow = false"
            />
          </van-cell>
        </van-cell-group>
        <div
          style="width: 90%;margin:0 5%;float: left;display:flex;margin-top:10px"
        >
          <div class="seatTitle">{{ $t("SetSeat.floorName") }}</div>
          <input
            class="tagInput"
            type="text"
            v-model="newFloor.name"
            :placeholder="$t('SetSeat.floorName')"
          />
        </div>
        <div class="submitBottom">
          <van-button
            class="submitBtn"
            round
            type="default"
            @click="addFloor()"
            style="font-weight:bold;font-size:16px;"
            >{{ $t("SetSeat.submit") }}</van-button
          >
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="isDelFloorShow"
      position="bottom"
      :style="{ height: '80%' }"
    >
      <div>
        <van-cell-group>
          <van-cell title="">
            <van-icon
              slot="right-icon"
              name="./static/img/dele_Seat.png"
              size="25px"
              @click="isDelFloorShow = false"
            />
          </van-cell>
        </van-cell-group>
        <!-- <van-cell title="删除楼层" style="color: #FFB20D;"/>  -->
        <van-checkbox-group v-model="delFloorResult" :max="1">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in seats"
              clickable
              :key="index"
              :title="item.name"
              @click="toggle(index)"
            >
              <van-checkbox :name="item.id" ref="checkboxes" slot="icon">
                <img
                  style="width: 20px;height: 20px"
                  slot="icon"
                  slot-scope="props"
                  :src="
                    props.checked
                      ? './static/img/sele.png'
                      : './static/img/unsele.png'
                  "
                />
              </van-checkbox>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <div class="submitBottom">
          <van-button
            class="submitBtn"
            round
            type="default"
            @click="delFloor()"
            style="font-weight:bold;font-size:16px;"
            >{{ $t("SetSeat.submit") }}</van-button
          >
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="isAddSeatShow"
      position="bottom"
      :style="{ height: '80%' }"
    >
      <div>
        <van-cell-group>
          <van-cell title="">
            <van-icon
              slot="right-icon"
              name="./static/img/dele_Seat.png"
              size="25px"
              @click="isAddSeatShow = false"
            />
            <!-- <van-icon
						    slot="icon"
						    name="./static/img/down.png"
						    size="25px"
						    @click="getSeatQRCode()"
					  	/> -->
          </van-cell>
          <div style="width: 100%;height: 160px;font-size: 14px">
            <div style="width: 90%;margin:0 5%;float: left">
              <div class="seatTitle">{{ $t("SetSeat.tableName") }}</div>
              <input
                type="text"
                class="seatInput"
                v-model="newSeat.name"
                :placeholder="$t('SetSeat.inputSeatNum')"
              />
            </div>
            <div style="width: 90%;margin:0 5%;float: left">
              <div class="seatTitle">{{ $t("SetSeat.setNum") }}</div>
              <input
                type="text"
                class="seatInput"
                v-model="newSeat.number"
                :placeholder="$t('SetSeat.inputNum')"
              />
            </div>
          </div>
          <div
            style="width: 100%;height: 130px;text-align: center;padding: 15px 0;"
          >
            <van-image v-if="image" width="130" height="130" :src="image" />
            <div v-else class="QRCodeBg">
              <van-icon
                name="./static/img/Refresh.png"
                size="25px"
                @click="getSeatQRCode()"
              />
            </div>
          </div>
        </van-cell-group>
      </div>
      <div class="submitBottom">
        <van-button class="addSeat1" @click="addSeat()" size="normal" round>{{
          $t("SetSeat.submit")
        }}</van-button>
      </div>
    </van-popup>
    <van-popup
      v-model="isEditPlaceShow"
      position="bottom"
      :style="{ height: '80%' }"
    >
      <div class="contentWrapper">
        <van-cell-group>
          <van-cell title="">
            <van-icon
              slot="right-icon"
              name="./static/img/dele_Seat.png"
              size="25px"
              @click="isEditPlaceShow = false"
            />
            <!-- <van-icon
						    slot="right-icon"
						    name="./static/img/down.png"
						    size="25px"
						    @click="downloadImg(actPlace.image.path,actPlace.name)"
					  	/> -->
          </van-cell>
          <div style="width: 100%;min-height: 140px;font-size: 14px">
            <div style="width: 90%;margin:0 5%;display:flex;margin-top:10px">
              <div class="seatTitle">ID</div>
              <input
                type="text"
                class="seatInput"
                v-model="actPlace.id"
                disabled="disabled"
              />
            </div>
            <div style="width: 90%;margin:0 5%;display:flex;margin-top:10px">
              <div class="seatTitle">{{ $t("SetSeat.tableName") }}</div>
              <input
                type="text"
                class="seatInput"
                v-model="actPlace.name"
                :placeholder="$t('SetSeat.inputSeatNum')"
              />
            </div>
            <div style="width: 90%;margin:0 5%;display:flex;margin-top:10px">
              <div class="seatTitle">{{ $t("SetSeat.setNum") }}</div>
              <input
                type="text"
                class="seatInput"
                v-model="actPlace.number"
                :placeholder="$t('SetSeat.inputSeat')"
              />
            </div>
          </div>
          <div style="width: 100%;text-align: center;">
            <van-image
              v-if="actPlace.image"
              width="130"
              height="130"
              :src="actPlace.image.path + '?count=' + clickCount"
            />
            <div v-else class="QRCodeBg" @click="getSeatQRCode()">
              {{ $t("SetSeat.QRCode") }}
            </div>
            <p
              v-if="actPlace.image"
              style="width: 90%;margin:auto;word-break: break-all;text-align: left;"
            >
              {{ actPlace.image.link }}
            </p>
          </div>
          <!-- 刷新二维码<img src="static/img/Refresh.png" class="refreshImg"> -->
          <!-- <div style="width: 100%;height: 30px;line-height: 30px;text-align: center;font-size: 16px;color: #333;" @click="refreshQRcode(actPlace.id)">刷新二维码</div> -->
          <div style="display:flex;margin-top:3%">
            <div class="seatTitle" style="width: 60%;margin:0 5%;float: left">
              {{ $t("SetSeat.UsurpedRefreshQRcode") }}
            </div>
            <van-button
              class="refreshBtn"
              block
              size="normal"
              round
              @click="refreshQRcode(actPlace.id)"
              >{{ $t("SetSeat.refresh") }}</van-button
            >
          </div>
          <div style="display:flex;margin-top:3%">
            <div style="margin:0 5%;float: left;width:60%">
              {{ $t("SetSeat.savePrint") }}
            </div>
            <van-button
              class="down"
              block
              size="normal"
              round
              @click="downloadImg(actPlace.image.path, actPlace.name)"
            >
              <!-- <img src="static/img/down.png" width="30px" height="30px" class="imgDown"> -->
              <span>{{ $t("SetSeat.download") }}</span>
            </van-button>
          </div>
          <div style="display:flex;margin-top:3%" v-if="actPlace.image">
            <div
              style="margin:0 5%;float: left;width:60%;word-break: break-all;line-height: 20px;"
            >
              {{ $t("SetSeat.copy") }}
            </div>
            <van-button
              class="refreshBtn"
              block
              size="normal"
              round
              @click="copy()"
            >
              <span>{{ $t("SetSeat.copy") }}</span>
            </van-button>
          </div>
        </van-cell-group>
      </div>
      <div class="submitBottom">
        <van-button class="addSeat" @click="editSeat()" size="normal" round>{{
          $t("SetSeat.submit")
        }}</van-button>
      </div>
    </van-popup>
    <!-- <van-icon style="position: fixed;right: 20px;bottom: 100px;" @click="downloadZip()" name="./static/img/QR_code.png" size="33px"/> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      actTab: 0,
      seats: [],
      newFloor: {
        name: "",
        store_id: sessionStorage.actShopId
      },
      newSeat: {
        name: "",
        number: "",
        image_id: ""
      },
      actPlace: {},
      isAddFloorShow: false,
      isDelFloorShow: false,
      delFloorResult: [],
      isAddSeatShow: false,
      isDelSeatShow: false,
      image: "",
      isEditPlaceShow: false,
      clickCount: 0
    };
  },
  mounted: function() {
    this.getSeats();
    var that = this;
    window.addEventListener("click", function() {
      that.clickCount++;
    });
  },
  methods: {
    getSeats() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + sessionStorage.actShopId + "/places"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.seats = res.data.data;
            console.log(this.seats);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetSeat.message")
          });
        });
    },
    addFloor() {
      if (this.newFloor.name) {
        this.$axios({
          method: "post",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/place/addFloor",
          data: this.newFloor
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              this.isAddFloorShow = false;
              this.newFloor.name = "";
              this.getSeats();
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("SetSeat.message")
            });
          });
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("SetSeat.inputFloorName")
        });
      }
    },
    delFloor() {
      if (this.delFloorResult) {
        this.$dialog
          .confirm({
            title: this.$t("SetSeat.delFloor"),
            message: this.$t("SetSeat.isDelFloor"),
            confirmButtonColor: "#2f75f4",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "DELETE",
              headers: {
                Authorization: "Bearer " + sessionStorage.token
              },
              url:
                this.$build +
                "/api/store/" +
                sessionStorage.actShopId +
                "/delete/" +
                this.delFloorResult[0]
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  this.isDelFloorShow = false;
                  this.delFloorResult = [];
                  this.getSeats();
                } else {
                  this.$toast.allowMultiple();
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("SetSeat.message")
                });
              });
          })
          .catch(() => {});
      } else {
      }
    },
    addSeat() {
      // if(this.newSeat.name&&this.newSeat.number&&this.newSeat.image_id){
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/place/store",
        data: {
          store_id: sessionStorage.actShopId,
          floor: this.seats[this.actTab].id
          // image_id:this.newSeat.image_id,
          // name:this.newSeat.name,
          // number:this.newSeat.number,
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.isAddSeatShow = false;
            this.newSeat = {
              name: "",
              number: "",
              image_id: ""
            };
            this.image = "";
            this.getSeats();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetSeat.message")
          });
        });
      //  		}else{
      //  			this.$toast({
      //          		type:'fail',
      //          		message:'清先填写完整信息',
      //      		});
      // }
    },
    editPlaceShow(index) {
      this.isEditPlaceShow = true;
      this.actPlace = this.seats[this.actTab].place[index];
    },
    editSeat() {
      if (this.actPlace.name && this.actPlace.number && this.actPlace.image) {
        this.$axios({
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/place/" + this.actPlace.id + "/update",
          data: {
            store_id: sessionStorage.actShopId,
            name: this.actPlace.name,
            number: this.actPlace.number,
            image_id: this.image.id,
            floor: this.actPlace.floor
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              this.isEditPlaceShow = false;
              this.image = "";
              this.getSeats();
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("SetSeat.message")
            });
          });
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("SetSeat.toast")
        });
      }
    },
    delSeat(id) {
      this.$dialog
        .confirm({
          title: this.$t("SetSeat.delSeat"),
          message: this.$t("SetSeat.isDelSeat"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel")
        })
        .then(() => {
          this.$axios({
            method: "DELETE",
            headers: {
              Authorization: "Bearer " + sessionStorage.token
            },
            url: this.$build + "/api/place/" + id + "/destroy"
          })
            .then(res => {
              console.log(res);
              if (res.data.status == 200) {
                this.$toast({
                  type: "success",
                  message: res.data.message
                });
                this.getSeats();
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item]
                  });
                }
              }
            })
            .catch(err => {
              this.$toast({
                type: "fail",
                message: this.$t("SetSeat.message")
              });
            });
        })
        .catch(() => {});
    },
    getSeatQRCode() {
      if (this.actPlace.name) {
        this.$axios({
          method: "post",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/qrcode",
          data: {
            store_id: sessionStorage.actShopId,
            name: this.actPlace.name,
            floor: this.seats[this.actTab].id
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.bindImage(res.data.success.image_id);
              this.$toast({
                type: "success",
                message: res.data.message
              });
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("SetSeat.message")
            });
          });
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("SetSeat.pleaseInputSeatNum")
        });
      }
    },
    bindImage(image_id) {
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/place/" + this.actPlace.id + "/binding",
        data: {
          image_id: image_id,
          name: this.actPlace.name,
          number: this.actPlace.number
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.actPlace = res.data.data;
          } else {
          }
        })
        .catch(err => {});
    },
    toggle(index) {
      if (this.delFloorResult.length >= 1) {
        this.delFloorResult = [];
      }
      this.$refs.checkboxes[index].toggle();
    },
    // 全部下载
    downloadZip() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        responseType: "blob",
        url:
          this.$build +
          "/api/place/makeZip/" +
          sessionStorage.actShopId +
          "/" +
          this.seats[this.actTab].id
      })
        .then(res => {
          console.log(res);
          if (res) {
            var filename = this.seats[this.actTab].name;
            let url = window.URL.createObjectURL(res.data);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", filename + ".zip");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetSeat.message")
          });
        });
    },
    downloadImg(url, filename) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", filename + ".png");
      document.body.appendChild(link);
      link.click();
    },
    refreshQRcode(id) {
      this.$dialog
        .confirm({
          title: this.$t("SetSeat.refresh"),
          message: this.$t("SetSeat.refreshTip"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel")
        })
        .then(() => {
          // /api/place/2/refresh
          this.$axios({
            method: "PATCH",
            headers: {
              Authorization: "Bearer " + sessionStorage.token
            },
            url: this.$build + "/api/place/" + id + "/refresh",
            data: {
              name: this.actPlace.name,
              number: this.actPlace.number
            }
          })
            .then(res => {
              console.log(res);
              if (res.data.status == 200) {
                this.actPlace = res.data.data;
                this.$toast({
                  type: "succsss",
                  message: res.data.message
                });
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item]
                  });
                }
              }
            })
            .catch(err => {
              this.$toast({
                type: "fail",
                message: this.$t("SetSeat.message")
              });
            });
        })
        .catch(() => {});
    },
    copy() {
      //复制当剪切板
      let transfer = document.createElement("input");
      document.body.appendChild(transfer);
      transfer.value = this.actPlace.image.link; // 这里表示想要复制的内容
      transfer.focus();
      transfer.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      transfer.blur();
      document.body.removeChild(transfer);
      this.$toast({
        duration: 800,
        type: "success",
        message: this.$t("CookInfo.copyScuess")
      });
    }
  }
};
</script>
<style scoped>
@media screen and (min-width: 800px) {
  /deep/ .van-sticky--fixed {
    width: 800px !important;
    margin: 0 auto;
  }
}
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
.nav {
  position: fixed;
  width: 100%;
}
/deep/ .van-tabs__line {
  background-color: #fd3f3f;
}
/deep/ .van-cell__left-icon {
  font-size: 25px;
}
/deep/ .van-tab {
  font-size: 16px;
}
/deep/ .van-icon {
  font-size: 25px;
}
/deep/ .van-cell__value > span {
  padding-left: 10px;
}
/deep/ .van-grid-item__content {
  background: #dfdede;
  border-radius: 4px;
}
/deep/ .van-popup {
  overflow: auto;
}
.contentWrapper {
  /* margin-bottom: 50px; */
  overflow: auto;
  height: 88%;
}
.van-cell__title {
  padding-left: 10px;
}
.home {
  width: 100%;
  height: 100vh;
  background-color: #fff;
}
.setBg {
  padding-bottom: 10px;
}
.setBg > div span {
  color: #000;
}
.mt10 {
  margin-top: 50px;
  margin-bottom: 90px;
}
.editBar {
  width: 100%;
  height: 76px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  justify-content: space-around;
  box-shadow: 10px 10px 20px #000;
  background-color: #000;
}
.editBar_item {
  width: 54px;
  height: 54px;
  border: 1px solid #000;
  background: #000;
  border-radius: 4px;
  margin-top: 10px;
  position: relative;
}
.editBar_item > .van-image {
  margin-left: 7px;
}
.editBar_title {
  position: absolute;
  bottom: 0;
  width: 54px;
  line-height: 12px;
  font-size: 12px;
  text-align: center;
  color: #fff;
  overflow: hidden;
}
.grid_item {
  /* position: relative; */
}
.grid_item_text {
  font-size: 14px;
  height: 20px;
  width: 115px;
  line-height: 20px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.grid_item_del_icon {
  position: absolute;
  right: 0px;
  top: 0px;
}
.tagInput {
  font-size: 14px;
  text-indent: 10px;
  width: 100%;
  height: 33px;
  line-height: 33px;
  border: 2px solid #000;
  margin-left: 5%;
  border-radius: 5px;
}
.addSeat1 {
  width: 90%;
  background-color: #000;
  color: #fff;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.addSeat {
  left: 5%;
  width: 90%;
  background-color: #000;
  color: #fff;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/* 刷新二维码按钮 */
.refreshBtn {
  width: 35%;
  background-color: #2f75f4;
  color: #fff;
  margin-right: 10px;
  font-weight: bold;
}
/* 下载二维码样式 */
.down {
  width: 35%;
  font-weight: bold;
  color: #fff;
  margin-right: 10px;
  background-color: #2f75f4;
}
.imgDown {
  vertical-align: middle;
  margin-left: -10px;
}
.QRCodeBg {
  width: 130px;
  height: 130px;
  line-height: 130px;
  background-color: #000;
  color: #fff;
  display: inline-block;
}
.seatTitle {
  width: 50%;
  height: 40px;
  line-height: 40px;
  color: #222;
}
.seatInput {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-indent: 10px;
  border: 2px solid #000;
  border-radius: 5px;
}
.submitBottom {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50px;
  background: #fff;
}
.submitBtn {
  background: #000;
  color: #fff;
  width: 90%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.refreshImg {
  width: 25px;
  height: 25px;
}
/*条码下载按钮样式*/
.downloadQRcode {
  font-size: 12px;
  line-height: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/Seat/SetSeat.vue